const MARKER_STYLES = ['font-size', 'color'];

export function styleListMarkers(html) {
  if (!html || !html.includes('<li')) return html;

  const template = document.createElement('template');
  template.innerHTML = html;

  template.content.querySelectorAll('li').forEach((li) => {
    MARKER_STYLES.forEach((prop) => {
      if (li.style.getPropertyValue(prop)) return;

      const styled = Array.from(li.querySelectorAll('[style]'))
        .find((el) => el.style.getPropertyValue(prop));

      if (styled) {
        li.style.setProperty(prop, styled.style.getPropertyValue(prop));
      }
    });
  });

  return template.innerHTML;
}

export default styleListMarkers;
